import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import moment from 'moment-timezone';
import 'moment/locale/pt-br';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { ptBR } from '@mui/x-date-pickers/locales';
import ThemeWrapper from './ThemeWrapper';
import { BrowserRouter as Router } from 'react-router-dom';

moment.locale('pt-br');

const root = ReactDOM.createRoot(document.getElementById('root'));
const app = (
  <LocalizationProvider
      dateAdapter={AdapterMoment}
      adapterLocale="pt-br"
      localeText={
          ptBR.components.MuiLocalizationProvider.defaultProps.localeText
      }
  >
    <ThemeWrapper>
      <Router>
        <App />
      </Router>
    </ThemeWrapper>
  </LocalizationProvider>
);

root.render(
  process.env.NODE_ENV === 'development'
    ? app
    : <React.StrictMode>{app}</React.StrictMode>
);